
// import AttendanceDashboard from './component/AttendanceDashboard'

import EmployeeAttendance from './components'

const Attendance = () => {
    return (
       
        //old Attendance
        // <AttendanceDashboard />

        //new Attendance
        <EmployeeAttendance/>
    )
}

export default Attendance
